import { render } from "./TaxStatements.vue?vue&type=template&id=2f91db68&scoped=true"
import script from "./TaxStatements.vue?vue&type=script&lang=js"
export * from "./TaxStatements.vue?vue&type=script&lang=js"

import "./TaxStatements.vue?vue&type=style&index=0&id=2f91db68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f91db68"]])

export default __exports__